<template>
  <v-layout row wrap justify-center fill-height>
    <v-layout row wrap justify-center style="max-width: 1440px">
      <v-flex xs12>
        <v-alert
            color="info"
            class="info"
            icon="info"
            value="true"
            v-if="$lang.current_lang === 'en' ? !!formatedHtmlHints['webshop.deactivation.en'] && !company.acceptingOrders : !!formatedHtmlHints['webshop.deactivation.de'] && !company.acceptingOrders"
            v-html="$lang.current_lang === 'en' ? formatedHtmlHints['webshop.deactivation.en'] : formatedHtmlHints['webshop.deactivation.de']">
        </v-alert>
        <v-layout row wrap class="py-2 pr-2 pl-3 mb-2 elevation-2" style="background-color: #2196f3 !important; width: 100%;"
            v-if="$lang.current_lang === 'en' ? !!formatedHtmlHints['webshop.page2.prefix.en'] : !!formatedHtmlHints['webshop.page2.prefix.de']"
            v-html="$lang.current_lang === 'en' ? formatedHtmlHints['webshop.page2.prefix.en'] : formatedHtmlHints['webshop.page2.prefix.de']">
        </v-layout>
      </v-flex>
      <v-flex xs12 md7 lg8 class="section table-wrap">
        <v-flex>
          <p>
            <b>{{ $lang.global.attention }}:</b> {{ $lang.global.foodAllergy }}
            <a :href="`tel:${company.phone}`">{{ $lang.global.callRestaurant }}</a>
          </p>
        </v-flex>
        <div class="v-table__overflow mb-4 pt-4">
          <table class="v-datatable v-table">
            <thead>
            <tr>
              <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.labels.quantity }}</th>
              <th colspan="2" role="columnheader" scope="col" class="column text-xs-left">{{ $lang.labels.name }}</th>
              <th role="columnheader" scope="col" class="column text-xs-right">{{ $lang.labels.total }}</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item, index) in orderInfo.items">
              <tr :key="index">
                <td class="text-xs-left">{{ item.quantity }}</td>
                <td colspan="2" class="text-xs-left">{{
                    item.name[$lang.current_lang] ? item.name[$lang.current_lang] :
                        item.name.en
                  }}
                  <br>
                  <span class="flex py-2 xs4 details" :style="goDark ? 'color: #ffffffb3' : ''"
                        v-if="item.selectedSize.name && !item.selectedSize.isDefault">{{ $lang.labels.size }}: {{
                      item.selectedSize.name[$lang.current_lang] ? item.selectedSize.name[$lang.current_lang] : item.selectedSize.name.en
                    }}
                </span>
                  <span class="flex py-2 xs4 details" :style="goDark ? 'color: #ffffffb3' : ''"
                        v-if="item.selectedStyle.name  && !item.selectedStyle.isDefault"><span
                      v-if="item.selectedSize.name && !item.selectedSize.isDefault">,&nbsp</span> {{
                      $lang.labels.style
                    }}: {{
                      item.selectedStyle.name[$lang.current_lang] ? item.selectedStyle.name[$lang.current_lang] : item.selectedStyle.name.en
                    }}
                </span>
                  <span class="flex py-2 xs4 details" :style="goDark ? 'color: #ffffffb3' : ''"
                        v-if="item.selectedVariants && item.selectedVariants.name  && !item.selectedVariants.isDefault">
                  <span
                      v-if="(item.selectedSize.name && !item.selectedSize.isDefault) || (item.selectedStyle.name && !item.selectedStyle.isDefault)">,&nbsp</span>
                  {{ $lang.labels.variant }}: {{
                      item.selectedVariants.name[$lang.current_lang] ? item.selectedVariants.name[$lang.current_lang] : item.selectedVariants.name.en
                    }}
                </span>
                  <span class="flex py-2 xs4 details" :style="goDark ? 'color: #ffffffb3' : ''" v-if="item.selectedOptions.length > 0">
                  <span
                      v-if="(item.selectedSize.name && !item.selectedSize.isDefault) || (item.selectedStyle.name && !item.selectedStyle.isDefault) || (item.selectedVariants.name && !item.selectedVariants.isDefault)">,&nbsp</span>{{
                      $lang.labels.options
                    }}:
                    <span v-for="(option, index) in item.selectedOptions" :key="index">
                      <span v-if="item.selectedOptions.length > 1 && index !== 0">,&nbsp</span>
                      {{ option.name[$lang.current_lang] ? option.name[$lang.current_lang] : option.name.en }} x
                      {{ option.quantity }}
                    </span>
                </span><br v-if="item.allergens && item.allergens.length > 0">
                  <span class="flex py-2 xs4 orangeTheme details"
                        v-if="item.allergens && item.allergens.length > 0"><span
                      class="pointerCursor"
                      @click="openAllergens(item.allergens)">{{ $lang.labels.showAllergens }}</span>
                </span><br v-if="item.comment">
                  <span class="flex py-2 xs12 details" v-if="item.comment">{{ $lang.labels.comment }}: {{
                      item.comment
                    }}</span>
                </td>
                <td class="text-xs-right">
                  <p :style="goDark ? 'color: white' : ''" class="price" :data-currency="company ? company.currencySymbol : ''">
                    {{
                      $store.state.calculatePrice(item.selectedSize, item.selectedVariants,
                          item.selectedOptions, item.quantity, item.quantityOfIncludedOptions)
                          .toFixed(2)
                    }}
                  </p>
                </td>
              </tr>
              <tr v-if="item.selected" :key="index + 10000">
                <td colspan="4">
                  <ul class="layout row wrap">
                    <li class="flex py-2 xs6" v-if="item.selectedSize.name" xs6>{{ $lang.labels.size }}: {{
                        item.selectedSize.name[$lang.current_lang] ? item.selectedSize.name[$lang.current_lang] : item.selectedSize.name.en
                      }}
                    </li>
                    <li class="flex py-2 xs6" v-if="item.selectedStyle.name" xs6>{{ $lang.labels.style }}: {{
                        item.selectedStyle.name[$lang.current_lang] ? item.selectedStyle.name[$lang.current_lang] : item.selectedStyle.name.en
                      }}
                    </li>
                    <li class="flex py-2 xs6" v-if="item.selectedVariants && item.selectedVariants.name" xs6>
                      {{ $lang.labels.variant }}: {{
                        item.selectedVariants.name[$lang.current_lang] ? item.selectedVariants.name[$lang.current_lang] : item.selectedVariants.name.en
                      }}
                    </li>
                    <li class="flex py-2 xs6" v-if="item.selectedOptions.length > 0" xs6>
                      {{ $lang.labels.options }}:
                      <ul class="pl-4">
                        <li v-for="(option, index) in item.selectedOptions" :key="index">
                          {{ option.name[$lang.current_lang] ? option.name[$lang.current_lang] : option.name.en }} x
                          {{ option.quantity }}
                        </li>
                      </ul>
                    </li>
                    <li class="flex py-2 xs12" v-if="item.comment" md12>{{ $lang.labels.comment }}: {{ item.comment }}
                    </li>
                    <li class="flex py-2 xs6 pointerCursor orangeTheme"
                        v-if="item.allergens && item.allergens.length > 0" @click="openAllergens(item.allergens)">
                      {{ $lang.labels.allergens }}
                    </li>
                    <li class="flex py-2 xs6" v-if="item.vatRate && item.vatRate > 0">{{ $lang.labels.vatRate }}:
                      {{ item.vatRate }}%
                    </li>
                  </ul>
                </td>
              </tr>
            </template>
            <tr v-if="deliveryCharges > 0">
              <td class="text-xs-left" style="min-width: 130px;">
                <span class="quantity">1</span>
              </td>
              <td class="text-xs-left">{{ $lang.labels.deliveryCharges }}</td>
              <td>&nbsp;</td>
              <td class="text-xs-right">
                <p :style="goDark ? 'color: white' : ''" class="price" :data-currency="company ? company.currencySymbol : ''">
                  {{ deliveryCharges.toFixed(2) }}
                </p>
              </td>
            </tr>
            <tr id="discount" v-if="discount || description || discountRuleName">
              <td class="text-xs-left" colspan="3">
                <p class="mb-0"><strong>{{ $lang.labels.discount }}<span
                    v-if="discountRuleName">: {{ discountRuleName }}</span></strong>
                </p>
                <p class="mb-0" v-if="description">{{ description }}</p>
              </td>
              <td class="text-xs-right" v-if="discount">-
                <p :style="goDark ? 'color: white' : ''" class="price" :data-currency="company ? company.currencySymbol : ''">
                  {{ discount.toFixed(2) }}
                </p>
              </td>
            </tr>
            <tr>
              <td class="text-xs-left" colspan="3"><strong>{{ $lang.labels.total }}</strong></td>
              <td class="text-xs-right"><p :style="goDark ? 'color: white' : ''" :data-price="total.toFixed(2)" class="price"
                                           :data-currency="company ? company.currencySymbol : ''">
                {{ total.toFixed(2) }}</p></td>
            </tr>
            </tbody>
          </table>
        </div>
        <v-layout row wrap align-center pt-4>
          <p class="inline mb-0 sub-title mr-3">{{ $lang.labels.deliveryMethod }}:</p>
          <p class="inline mb-0 mr-3">{{ $lang.actions[orderInfo.orderType] }}</p>
          <p class="inline mb-0" v-if="company && company.orderTypes && company.orderTypes.length > 1">(<a
              class="inline"
              @click.prevent.stop="goBack">{{ $lang.labels.change }}</a>)</p>
        </v-layout>
        <v-layout row wrap align-center v-if="orderInfo.comment">
          <p class="inline sub-title mr-3">{{ $lang.labels.comment }}:</p>
          <p>{{ orderInfo.comment }}</p>
        </v-layout>
      </v-flex>
      <v-flex xs12 md5 lg4 class="section order-wrap">
        <v-card class="pa-4">
          <v-form v-model="valid" @submit.stop.prevent="calcAll">
            <template v-if="orderInfo.orderType === 'delivery'">
              <v-flex xs12 class="mb-0">
                <p class="sub-title inline mr-1">{{ $lang.labels.address }}:</p>
              </v-flex>
              <v-layout row wrap align-center class="mb-2">
                <v-flex xs11 class="mb-0 pr-2">
                <p v-if="chosenAddress">{{generateFullAddress(chosenAddress)}}</p>
                </v-flex>
                <v-flex xs1 class="mb-0 pb-4">
                  <v-btn fab flat dark small color="primary" class="mx-0 mr-2"
                         @click.stop="goBack">
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </template>
            <v-layout row wrap v-if="!isLoggedIn">
              <v-flex xs12>
                <p class="px-2 mb-1 sub-title">{{ $lang.labels.contactInfo }}:</p>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                    id="firstName"
                    :label="$lang.labels.first"
                    v-model="firstName"
                    name="firstName"
                    :rules="firstNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                    id="lastName"
                    :label="$lang.labels.last"
                    v-model="lastName"
                    name="lastName"
                    :rules="lastNameRules"
                    required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 class="px-2">
                <v-text-field
                    id="phone"
                    :label="$lang.labels.phone"
                    v-model="phone"
                    name="phone"
                    :rules="[phoneNumberRules]"
                    required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 class="px-2">
                <v-text-field
                    id="email"
                    :label="$lang.labels.email"
                    v-model="email"
                    name="email"
                    :rules="emailRules"
                    required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="px-2">
              <v-flex xs12>
                <v-layout row wrap justify-start class="mt-3">
                  <v-flex class="payment-method">
                    <p class="inline sub-title mr-3">{{ $lang.labels.paymentMethod }}:</p>
                  </v-flex>
                  <v-flex class="radio-wrap">
                    <v-radio-group v-model="paymentMethod" class="pt-0">
                      <v-layout v-if="company && company.paymentTypes" row wrap justify-start
                                align-center class="radio-wrap pt-0">
                        <v-flex v-for="(method, index) in company.paymentTypes" :key="index">
                          <v-radio
                              type="radio"
                              :label="$lang.global[method]"
                              :value="method"
                              class="single-radio"/>
                        </v-flex>
                      </v-layout>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap justify-space-between>
                  <v-text-field
                      :label="$lang.labels.voucher"
                      name="voucher"
                      v-model="voucher"
                      @blur="calcAll"
                  ></v-text-field>
                </v-layout>
              </v-flex>
              <v-flex xs12 class="mt-2">
                <p class="mb-0 mr-3 sub-title inline">{{ orderTimeLabel() }} {{ $lang.labels.time }}:</p>
                <p class="inline">{{ formatOrderTime(orderTime) }}</p>
                <v-btn fab flat dark small color="primary" class="mx-0 mr-2"
                       @click.stop="timeDialog = true">
                  <v-icon dark>edit</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row class="agreement px-2" justify-start v-if="!isLoggedIn">
              <v-checkbox v-model="agreement"/>
              <p class="pl-2">{{ $lang.header.iAgree1 }} <a
                  v-if="formatedHtmlHints['webshop.footer.termins-and-conditions-link']"
                  :href="`/${$route.params.lang}/${formatedHtmlHints['webshop.footer.termins-and-conditions-link']}`"
                  target="_blank">{{ $lang.header.tearmsConditions }}</a>
                <a v-else :href="`/${$route.params.lang}/terms-and-Conditions`"
                   target="_blank">{{ $lang.header.tearmsConditions }}</a>
                {{ $lang.header.and }}
                <a v-if="formatedHtmlHints['webshop.footer.privacy-and-cookies-policy-link']"
                   class="mr-3"
                   :href="`/${$route.params.lang}/${formatedHtmlHints['webshop.footer.privacy-and-cookies-policy-link']}`"
                   target="_blank">{{ $lang.header.cookiePrivacy }}</a>
                <a v-else class="mr-3" :href="`/${$route.params.lang}/data-protection-policy`"
                   target="_blank">{{ $lang.header.cookiePrivacy }}</a>
                {{ $lang.header.iAgree2 }}
              </p>
            </v-layout>
            <v-flex xs12 px-2>
              <v-alert
                  color="success"
                  class="success"
                  icon="warning"
                  value="true"
                  v-if="success">{{ success }}
              </v-alert>
              <v-alert
                  color="error"
                  class="err"
                  icon="warning"
                  value="true"
                  v-if="err">{{ err }}
              </v-alert>
            </v-flex>
            <v-layout row justify-space-between class="px-2">
              <v-btn class="ma-0" @click="goBack">
                {{ $lang.actions.back }}
              </v-btn>
              <v-btn id="order" v-if="closed && remainingWorkingRanges.length > 0" @click="submit"
                     color="primary">{{ $lang.actions.preorder }}
              </v-btn>
              <v-btn id="order" v-else class="ma-0" :disabled="submitted" color="primary" @click="submit">
                {{ $lang.actions.placeOrder }}
              </v-btn>
            </v-layout>
          </v-form>
        </v-card>
        <v-dialog v-model="timeDialog" v-if="timeDialog" max-width="600px">
          <Time @close="closeDialog('time')" :time="orderTime" @submit="submitTime"/>
        </v-dialog>
        <v-dialog scrollable :fullscreen="width < 768" v-model="allergensDialog" v-if="allergensDialog"
                  max-width="200px">
          <Allergens @close="closeDialog('allergens')" :allergens="allergens" :catalogAllergens="catalog.allergens"/>
        </v-dialog>
      </v-flex>
      <v-flex xs12 px-0>
        <v-layout row wrap class="py-2 pr-2 pl-3 mb-2 elevation-2" style="background-color: #2196f3 !important; width: 100%;"
            v-if="$lang.current_lang === 'en' ? !!formatedHtmlHints['webshop.page2.postfix.en'] : !!formatedHtmlHints['webshop.page2.postfix.de']"
            v-html="$lang.current_lang === 'en' ? formatedHtmlHints['webshop.page2.postfix.en'] : formatedHtmlHints['webshop.page2.postfix.de']">
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import AddressInline from '@/components/webshop/modals/AddressInline';
import Allergens from '@/components/webshop/modals/Allergens';
import Time from '@/components/webshop/modals/Time';
import auth from '@/auth';

export default {
  components: {
    AddressInline,
    Time,
    Allergens,
  },
  data() {
    return {
      isLoading: false,
      firstNameRules: [
        v => ((v && v.length <= 35) || v === '') || this.$lang.errors.nameLess,
      ],
      lastNameRules: [
        v => !!v || this.$lang.errors.required,
        v => (v && v.length <= 35) || this.$lang.errors.nameLess,
      ],
      emailRules: [
        v => !!v || this.$lang.errors.requiredEmail,
        // eslint-disable-next-line
        v => (v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase())) || this.$lang.errors.notValidEmail,
      ],
      err: '',
      success: '',
      total: 0,
      select: null,
      submitted: false,
      validPostal: false,
      chosenAddress: undefined,
      contact: undefined,
      email: '',
      phone: '',
      agreement: false,
      firstName: '',
      lastName: '',
      valid: true,
      deliveryCharges: 0,
      distanceInMiles: 0,
      orderTime: -1,
      timeDialog: false,
      paymentMethod: undefined,
      selectAddress: '',
      isLoggedIn: auth.isLoggedIn(),
      items: [],
      discount: 0,
      description: '',
      totalAmountWithoutDiscount: 0,
      discountRuleName: '',
      voucher: '',
      zone: moment.tz.guess(),
      canGoIntoNextDay: false,
      htmlHints: [],
      formatedHtmlHints: {},
      allergensDialog: false,
      allergens: [],
      postalCodes: [],
      search: null,
      searchAddress: null,
      hint: '',
      postalcode: '',
      resourceId: null,
      defaultPaymentType: '',
    };
  },
  computed: {
    ...mapGetters({
      orderInfo: 'orderInfo',
      width: 'width',
      company: 'company',
      addresses: 'addresses',
      addressesAT: 'addressesAT',
      selectedAddress: 'selectedAddress',
      closed: 'closed',
      closedMessage: 'closedMessage',
      postalCode: 'postalCode',
      remainingWorkingRanges: 'remainingWorkingRanges',
      workingHours: 'currentWorkingHours',
      tomorrowsWorkingHours: 'tomorrowsWorkingHours',
      userData: 'userData',
      catalog: 'catalog',
      goDark: 'goDark',
    }),
    postalCodeRules() {
      if (this.company && this.postalcode) {
        if (this.testPostalCodeRules(this.company.address.country, this.postalcode) !== true) this.startErrorAnimation('elPostalAutocomplete');
        return this.testPostalCodeRules(this.company.address.country, this.postalcode);
      }
      return this.$lang.errors.invalidZip;
    },
    phoneNumberRules() {
      if (this.company && (this.phone || this.phone !== '')) {
        return this.testPhoneNumberRules(this.company.address.country, this.phone);
      }
      return this.$lang.errors.requiredPhone;
    },
    showInfoPre() {
      if (this.$lang.current_lang === 'en') {
        return !!this.formatedHtmlHints['webshop.page2.prefix.en'];
      }
      if (this.$lang.current_lang === 'de') {
        return !!this.formatedHtmlHints['webshop.page2.prefix.de'];
      }
      return false;
    },
    showInfoPost() {
      if (this.$lang.current_lang === 'en') {
        return !!this.formatedHtmlHints['webshop.page2.postfix.en'];
      }
      if (this.$lang.current_lang === 'de') {
        return !!this.formatedHtmlHints['webshop.page2.postfix.de'];
      }
      return false;
    },
  },
  methods: {
    startErrorAnimation(elementId) {
      const el = document.getElementById(elementId);
      if (el) {
        el.classList.add('ahashakeheartache');
        setTimeout(() => {
          el.classList.remove('ahashakeheartache');
        }, 800);
      }
    },
    getPostalCodes(code) {
      if (!code) return;
      code.trim()
        .toUpperCase();
      this.hint = '';
      if (this.company.address.country === 'UK' && (code.length < 4 || code.length > 16)) return;
      if (this.company.address.country === 'AT' && code.length !== 4) return;
      this.isLoading = true;
      this.$webHelper.get(`address/postalcodes/${this.resourceId}`, {
        startswith: code.trim()
          .toUpperCase(),
      })
        .then((res) => {
          if (res.body && res.status === 200) {
            if (res.body.postalCodes.length === 0) {
              this.hint = this.$lang.errors.noPostalFound;
              this.isLoading = false;
            } else {
              if ((res.body.postalCodes.filter(x => x === this.postalcode)).length === 0) {
                this.postalCodes = res.body.postalCodes;
              }
              this.isLoading = false;
            }
          }
        })
        .catch((err) => {
          this.err = err;
          this.isLoading = false;
        });
    },
    getPrefill(value) {
      if (!value) return;
      if (this.fromBack) {
        this.fromBack = false;
        return;
      }
      if (this.company.address.country === 'UK' && (value.length < 5 || value.length > 16)) return;
      if (this.company.address.country === 'AT' && value.length !== 4) return;
      if ((!value || !this.searchAddress || this.searchAddress.length < 3) && this.company.address.country === 'AT') return;
      if (this.searchAddress && this.searchAddress.split(',').length === 4 && this.company.address.country === 'AT') return;
      const payload = this.company.address.country === 'AT' ?
      // eslint-disable-next-line max-len
        { postalCode: value.toUpperCase(), line1: this.searchAddress, country: this.company.address.country } :
        { postalCode: value.toUpperCase(), country: this.company.address.country };
      if (this.resourceId) {
        this.$webHelper.post(`address/${this.resourceId}`, payload)
          .then((res) => {
            if (res.body && res.status === 200 && res.body.addresses) {
              this.hint = this.$lang.success.postalSet;
              this.latitude = res.body.addresses[0].latitude;
              this.longitude = res.body.addresses[0].longitude;
              this.isLoading = false;
              this.$store.dispatch('addPostal', {
                postalCode: this.postalcode,
                latitude: this.latitude || res.body.addresses[0].latitude,
                longitude: this.longitude || res.body.addresses[0].longitude,
              });
              this.$store.dispatch('setAddressesAT', res.body.addresses);
            } else {
              this.hint = res.body.statusText;
              this.isLoading = false;
            }
          })
          .catch((err) => {
            this.err = err;
            this.isLoading = false;
          });
      }
    },
    onBlurPostal() {
      if (this.postalCodes.includes(this.search)) {
        this.postalcode = this.search;
        this.getPrefill(this.postalcode);
      }
    },
    testPostalCodeRules(country, zip) {
      if (!zip) return this.$lang.errors.zipRequired;
      if (!country) return this.$lang.errors.countryRequired;
      if (country === 'UK') {
        return zip.length > 5 && zip.length < 16;
      }
      if (country === 'AT') {
        return zip.length === 4;
      }
      return this.$lang.errors.countryUnsupported;
    },
    openAllergens(allergens) {
      this.allergens = allergens;
      this.allergensDialog = true;
    },
    selectCartItem(index) {
      this.$store.dispatch('selectItem', index);
    },
    formatHtmlHints() {
      for (let i = 0; i < this.htmlHints.length; i += 1) {
        this.formatedHtmlHints[this.htmlHints[i].name] = `<v-flex xs1><i class="material-icons pr-3">info</i></v-flex><v-flex xs11>${this.htmlHints[i].value}</v-flex>`;
      }
    },
    testPhoneNumberRules(country, phone) {
      if (!phone) return this.$lang.errors.requiredPhone;
      if (!country) return this.$lang.errors.countryRequired;
      if (country === 'UK') {
        return ([10, 11].includes(phone.replace(/\+|-|_|\/|(|)/g, '').length) &&
            /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/.test(phone)) || this.$lang.errors.notValidPhone;
      }
      if (country === 'AT') {
        let tempPhone = phone.replace(/\+|-|_| |\/|(|)/g, '');
        if (tempPhone.substring(0, 2) === '00') {
          tempPhone = tempPhone.substring(2, tempPhone.length);
        }
        if (tempPhone.substring(0, 2) === '43') {
          tempPhone = `0${tempPhone.substring(2, tempPhone.length)}`;
        }
        let checkPhone = /^0(6[045679][0469]){1}(-)?(1)?[^0\D]{1}\d{6,7}$/.test(tempPhone);
        if (!checkPhone) {
          checkPhone = /^[0-9]*$/.test(tempPhone) && [8, 9, 10, 11, 12, 13].includes(tempPhone.length);
        }
        return checkPhone || this.$lang.errors.notValidPhone;
      }
      return this.$lang.errors.countryUnsupported;
    },
    formatOrderTime(time) {
      if (time === -1) return this.$lang.labels.asSoon;
      return time.format('HH:mm');
    },
    inNewTab(name) {
      const routeData = this.$router.resolve({ name });
      window.open(routeData.href, '_blank');
    },
    generateAddress(lines) {
      return lines.filter(line => !!line)
        .join(', ');
    },
    orderTimeLabel() {
      return this.$lang.actions[this.orderInfo.orderType];
    },
    checkExistingAddress(address) {
      let addressFound = false;
      if (this.addresses && this.addresses.length > 0) {
        this.addresses.forEach((current) => {
          // eslint-disable-next-line max-len
          if (this.generateFullAddress(address) === this.generateFullAddress(current)) addressFound = true;
        });
      }
      return addressFound;
    },
    generateFullAddress(address) {
      const lines = this.generateAddress([
        address.line1,
        address.line2,
        address.line3,
        address.line4,
      ]);
      let fullAdderss = lines;
      if (address.locality) {
        fullAdderss += `, ${address.locality}`;
      }
      return `${fullAdderss}, ${address.townCity}, ${address.postalCode}`;
    },
    submitAddress(address) {
      this.chosenAddress = address;
      this.$store.dispatch('addPostal', {
        postalCode: this.postalcode,
        latitude: this.latitude,
        longitude: this.longitude,
      });
      this.$store.dispatch('setAddressesAT', [address]);
      this.$store.dispatch('chooseAddress', 0);
      this.closeDialog('address');
    },
    submitTime(time) {
      this.orderTime = time;
      this.closeDialog('time');
    },
    deleteAddress() {
      this.chosenAddress = undefined;
      this.deliveryCharges = 0;
      this.selectAddress = '';
    },
    closeDialog(type) {
      this.$store.dispatch('setModal', false);
      if (type === 'allergens') {
        this.allergens = [];
        this.allergensDialog = false;
      } else {
        this.timeDialog = false;
      }
    },
    goBack() {
      this.$router.push({ name: 'webShop', params: { fromBack: true, address: this.chosenAddress } });
    },
    findNextWorkingTime(picked) {
      let foundHours;
      this.workingHours.forEach((range) => {
        if (!foundHours &&
            (moment(range.startDate)
              .isAfter(picked) || range.startDate === picked.toISOString())
        ) {
          foundHours = range.start;
        }
      });
      return foundHours;
    },
    doubleDigits(time) {
      return `${time}`.length === 1 ? `0${time}` : time;
    },
    isInWorkingHours(picked) {
      let inside = false;
      this.workingHours.forEach((entry) => {
        const start = moment(entry.startDate);
        const end = moment(entry.endDate);
        if (picked.isBetween(start, end) || picked.toISOString() === entry.startDate) {
          inside = true;
        }
        if (
          !inside &&
            (start.isBefore(picked) && entry.end === 2359 && this.canGoIntoNextDay)
        ) {
          inside = true;
        }
      });
      return inside;
    },
    cleanUp() {
      this.submitted = false;
      this.$storage.order = null;
      this.$store.dispatch('clearCart');
      this.$router.push({ name: 'webShop', query: { orderSuccessful: true } });
    },
    async submit() {
      this.err = '';
      if ((this.closed && this.remainingWorkingRanges === 0) || this.submitted) return;
      if (this.company.webShopResourceStatus !== 'active') return;
      const isLoggedIn = auth.isLoggedIn();
      if (isLoggedIn && !this.contact) {
        this.err = this.$lang.errors.choseContact;
        return;
      }
      if (!isLoggedIn && !this.agreement) {
        this.err = this.$lang.errors.acceptAgreement;
        return;
      }
      if (this.orderInfo.orderType === 'delivery') {
        if (!this.chosenAddress) {
          this.err = this.$lang.errors.addAddress;
          return;
        }
        if (!this.validPostal) {
          this.err = this.$lang.errors.validPostal;
          return;
        }
        if (
          this.company &&
            this.company.minDeliveryAmount &&
            this.total < parseFloat(this.company.minDeliveryAmount)
        ) {
          this.err = `${this.$lang.errors.totalOver} ${parseFloat(this.company.minDeliveryAmount)
            .toFixed(2)} ${this.$lang.errors.thisDelivery}`;
          return;
        }
      }
      if (!isLoggedIn) {
        if (!this.phone) {
          this.err = this.$lang.errors.enterPhone;
          return;
        }
        if (!this.email) {
          this.err = this.$lang.errors.enterEmail;
          return;
        }
        if (!this.lastName) {
          this.err = this.$lang.errors.enterLastName;
          return;
        }
        if (!this.valid) return;

        const data = {
          first: this.firstName || '',
          last: this.lastName || '',
          email: this.email || '',
          phone: this.phone || '',
        };
        localStorage.customerData = JSON.stringify(data);
      }
      if (!this.paymentMethod) {
        this.err = this.$lang.errors.enterPayment;
        return;
      }
      this.submitted = true;

      if (this.orderTime !== -1 && !this.isInWorkingHours(this.orderTime)) {
        this.err = this.$lang.errors.workingHours;
        this.submitted = false;
        return;
      }
      const durationFrom = this.company.deliveryDurationFrom;
      if (this.orderTime === -1) {
        this.orderTime = moment()
          .add(durationFrom, 'minutes');
        const currentTime = this.orderTime;
        if (!this.isInWorkingHours(currentTime)) {
          const foundHours = this.findNextWorkingTime(currentTime);
          if (!foundHours) {
            this.err = this.$lang.errors.restaurantReceiving;
            this.submitted = false;
            return;
          }
          const now = moment();
          const orderHours = moment(`${now.format('YYYY-MM-DD')} ${foundHours}`, 'YYYY-MM-DD HH:mm')
            .add(durationFrom, 'minutes');
          if (!this.isInWorkingHours(orderHours)) {
            this.err = this.$lang.errors.restaurantReceiving;
            this.submitted = false;
            return;
          }
          this.orderTime = orderHours;
        }
      }
      const totalCalc = await this.calcAll(true);
      if (!totalCalc) {
        this.submitted = false;
        return;
      }
      const order = {};
      const items = this.orderInfo.items.map((current, index) => {
        const item = current;
        item.itemId = index;
        return item;
      });
      Object.assign(order, {
        items,
        comment: this.orderInfo.comment || '',
        type: this.orderInfo.orderType,
      });
      const contact = {};
      const phone = this.phone.replace(/\//g, '-');
      if (this.orderInfo.orderType === 'delivery') {
        Object.assign(contact, { address: this.chosenAddress });
      }
      if (this.contact) {
        Object.assign(contact, {
          contactId: this.contact.id,
          firstName: this.contact.firstName,
          lastName: this.contact.lastName,
          phone: this.contact.phone.replace(/\//g, '-'),
          email: this.contact.email,
        });
      } else {
        Object.assign(contact, { lastName: this.lastName });
        if (this.firstName) {
          Object.assign(contact, { firstName: this.firstName });
        }
        if (this.email) {
          Object.assign(contact, { email: this.email });
        }
        if (this.phone) {
          Object.assign(contact, { phone });
        }
        this.$store.dispatch('setUserData', {
          firstName: this.firstName,
          lastName: this.lastName,
          phone,
          email: this.email,
        });
      }
      Object.assign(order, {
        contact,
        deliveryTime: this.orderTime.toISOString(),
        driverNote: '',
        deliveryCharges: this.deliveryCharges,
        distanceInMiles: this.distanceInMiles,
      });
      const total = this.total.toFixed(2);
      Object.assign(order, {
        payments: [{
          paymentType: this.paymentMethod,
          amount: total,
        }],
        totalAmount: parseFloat(total),
      });
      if (this.voucher) {
        Object.assign(order, {
          voucher: this.voucher,
          discount: this.discount,
          discountRuleName: this.discountRuleName,
          totalAmountWithoutDiscount: this.totalAmountWithoutDiscount.toFixed(2),
        });
      }
      if (localStorage.tokenId) {
        Object.assign(order, {
          tokenId: JSON.parse(localStorage.tokenId).tokenId,
        });
      }
      const res = await this.$webHelper.post('order/create', order, this.$router);
      if (!res.success) {
        // eslint-disable-next-line max-len
        this.err = res.body && res.body.statusText ? res.body.statusText : this.$lang.errors.failedOrder;
        this.submitted = false;
        return;
      }
      localStorage.removeItem('webshop_voucher');
      const ordercompletedlink = localStorage.ordercompletedlink ?
        JSON.parse(localStorage.ordercompletedlink) : false;
      if (ordercompletedlink) {
        ordercompletedlink.orderId = res.body.orderId;
        localStorage.ordercompletedlink = JSON.stringify(ordercompletedlink);
      }
      if (isLoggedIn && this.orderInfo.orderType === 'delivery') {
        const addAddress = this.checkExistingAddress(this.chosenAddress);
        if (!addAddress) {
          const postAddresses = this.addresses;
          postAddresses.push(this.chosenAddress);
          this.$webHelper.post('contact/update', {
            address: postAddresses,
            phone,
            lastName: this.contact.lastName,
          }, this.$router)
            .then((res2) => {
              if (!res2.success) {
                this.err = this.$lang.errors.failedAddress;
              }
            });
        }
      }
      if (this.paymentMethod.toLowerCase() === 'card' && this.company.paymentGateway !== null && res.body.hostedPaymentFormURL) {
        if (res.body.paymentMethod === 'GET') {
          window.location = res.body.hostedPaymentFormURL;
        }
        if (res.body.paymentMethod === 'POST' && res.body.paymentParameters !== null) {
          const payload = res.body.paymentParameters;
          const form = document.createElement('form');
          form.style.visibility = 'hidden'; // no user interaction is necessary
          form.method = 'POST'; // forms by default use GET query strings
          form.action = res.body.hostedPaymentFormURL;
          const payloadKeys = Object.keys(payload);
          // eslint-disable-next-line no-undef,guard-for-in,no-restricted-syntax
          for (let i = 0; i < payloadKeys.length; i += 1) {
            const input = document.createElement('input');
            input.name = payloadKeys[i];
            input.value = payload[payloadKeys[i]];
            form.appendChild(input); // add key/value pair to form
          }
          document.body.appendChild(form); // forms cannot be submitted outside of body
          form.submit(); // send the payload and navigate
        }
        return;
      }
      this.cleanUp();
    },
    async calcDelivery() {
      const totalAmount = await this.calcTotalWithoutDelivery();
      if (totalAmount === null) return true;
      const res = await this.$webHelper.post('order/calculatedeliverycharges', {
        latitude: this.chosenAddress ? this.chosenAddress.latitude : this.postalCode.latitude,
        longitude: this.chosenAddress ? this.chosenAddress.longitude : this.postalCode.longitude,
        postalCode: this.chosenAddress ? this.chosenAddress.postalCode : this.postalCode.postalCode,
        country: this.chosenAddress ? this.chosenAddress.country : this.company.address.country,
        totalAmount,
      }, this.$router);
      if (!res.success) {
        this.validPostal = false;
        this.err = this.$lang.errors.failedCalculate2;
        this.distanceInMiles = 0;
        this.deliveryCharges = 0;
        return false;
      }
      this.validPostal = true;
      this.distanceInMiles = res.body.distanceInMiles;
      this.deliveryCharges = res.body.deliveryCharges;
      return true;
    },
    async calcTotalWithoutDelivery() {
      const data = {
        items: this.orderInfo.items.map((current, index) => {
          const item = current;
          item.itemId = index;
          return item;
        }),
        type: this.orderInfo.orderType,
        paymentMethod: this.paymentMethod,
      };
      const res = await this.$webHelper.post('order/calculatetotalamount', data, this.$router);
      return !res.success ? null : res.body.itemsTotalAmount;
    },
    async calcTotal(isSubmit) {
      const data = {
        items: this.orderInfo.items.map((current, index) => {
          const item = current;
          item.itemId = index;
          return item;
        }),
        deliveryCharges: this.deliveryCharges,
        distanceInMiles: this.distanceInMiles,
        type: this.orderInfo.orderType,
        paymentMethod: this.paymentMethod,
      };
      if (this.voucher) {
        Object.assign(data, { voucher: this.voucher });
      }
      const res = await this.$webHelper.post('order/calculatetotalamount', data, this.$router);
      if (!res.success) {
        if (
          res.body && res.body.statusText &&
            res.body.statusText.includes('Invalid Voucher')
        ) {
          localStorage.removeItem('webshop_voucher');
        }
        if (isSubmit) {
          // eslint-disable-next-line max-len
          this.err = res.body && res.body.statusText ? res.body.statusText : this.$lang.errors.calculateServer;
        } else {
          this.warn = this.$lang.errors.calculateServer;
        }
        return false;
      }
      this.total = res.body.totalAmount;
      this.totalAmountWithoutDiscount = res.body.totalAmountWithoutDiscount;
      this.discount = res.body.totalDiscountAmount;
      this.discountRuleName = res.body.discountRuleName;
      this.description = res.body.discountRuleDescription;
      if (this.voucher) {
        localStorage.setItem('webshop_voucher', this.voucher);
      } else {
        localStorage.removeItem('webshop_voucher');
      }
      return true;
    },
    calcTotalOffline() {
      this.total = this.orderInfo.items.length === 0
        ? 0
        : this.orderInfo.items.reduce(
          (total, current) =>
            total +
                  this.$store.state.calculatePrice(
                    current.selectedSize,
                    current.selectedVariants,
                    current.selectedOptions,
                    current.quantity,
                    current.quantityOfIncludedOptions,
                  ),
          0,
        );
      this.totalAmountWithoutDiscount = this.total;
    },
    async calcAll(isSubmit = false) {
      if (
        this.orderInfo.orderType === 'delivery' &&
          (this.postalCode ||
              (this.chosenAddress && this.chosenAddress.postalCode))
      ) {
        const deliveryRes = await this.calcDelivery();
        if (!deliveryRes) return false;
        return this.calcTotal(isSubmit);
      }
      this.distanceInMiles = 0;
      this.deliveryCharges = 0;
      return this.calcTotal(isSubmit);
    },
    setPayment() {
      if (!this.company.paymentTypes) return;
      if (this.company.defaultPaymentType) this.paymentMethod = this.company.defaultPaymentType;
      if (this.company.defaultPaymentType) {
        this.paymentMethod = this.company.defaultPaymentType;
      } else {
        this.paymentMethod = this.company.paymentTypes[0];
      }
    },
    removeAddress() {
      if (this.search && this.postalcode === this.search.trim()) return;
      this.chosenAddress = undefined;
      this.line1 = '';
      if (this.selectAddress) {
        const tempPostal = this.selectAddress.split(',')[4];
        if (tempPostal.trim() !== this.postalcode) {
          this.selectAddress = null;
          this.$store.dispatch('removeAddress');
        }
      }
    },
    // eslint-disable-next-line consistent-return
    findPos(obj) {
      let curtop = 0;
      if (obj.offsetParent) {
        // eslint-disable-next-line no-cond-assign
        do {
          curtop += obj.offsetTop;
          // eslint-disable-next-line no-param-reassign
        } while (obj = obj.offsetParent);
        return [curtop];
      }
      return [curtop];
    },
  },
  watch: {
    search: {
      handler(val) {
        if (val) {
          this.search = this.search.trim();
        }
        this.getPostalCodes(val);
        if (!auth.isLoggedIn()) {
          this.removeAddress();
        }
      },
      deep: true,
    },
    searchAddress: {
      handler(val) {
        if (val) {
          this.searchAddress = this.searchAddress.trim();
        }
        this.getPrefill(this.postalcode);
      },
      deep: true,
    },
    selectAddress(newValue) {
      this.contact.address.forEach((current) => {
        if (this.generateFullAddress(current) === newValue) {
          this.chosenAddress = current;
        }
      });
    },
    chosenAddress() {
      if (this.chosenAddress !== undefined) {
        this.calcAll();
      }
    },
    paymentMethod() {
      this.calcAll();
    },
    postalcode() {
      this.validPostal = null;
      this.postalcode = this.postalcode ? this.postalcode.trim() : '';
    },
    err() {
      setTimeout(() => {
        this.err = '';
      }, 7000);
    },
  },
  created() {
    setTimeout(() => {
      window.scroll(0, this.findPos(document.getElementById('headerCard')) - 8);
    }, 400);
    this.resourceId = localStorage.getItem('webShopResourceId');
    if (this.company && this.company.htmlHints) {
      this.htmlHints = this.company.htmlHints;
      this.formatHtmlHints();
    }
    if (
      this.orderInfo.items.length === 0 ||
        ((this.closed || this.closedMessage) && this.remainingWorkingRanges.length === 0) ||
        (this.orderInfo.orderType === 'delivery' && !this.postalCode && this.selectedAddress === null)
    ) {
      this.$router.push({ name: 'webShop' });
      return;
    }
    if (this.userData) {
      Object.keys(this.userData)
        .forEach((key) => {
          this[key] = this.userData[key] !== 'undefined' ? this.userData[key] : '';
        });
    }
    this.setPayment();
    const day1End = moment(this.workingHours[this.workingHours.length - 1].endDate);
    if (this.tomorrowsWorkingHours[0]) {
      const day2Start = moment(this.tomorrowsWorkingHours[0].startDate)
        .add(1, 'day');
      const duration = moment.duration(day2Start.diff(day1End))
        .asMinutes();
      this.canGoIntoNextDay = duration === 1;
    }
    const voucher = localStorage.getItem('webshop_voucher');
    if (voucher) {
      this.voucher = voucher;
    }
    this.calcAll();
    if (auth.isLoggedIn()) {
      this.$webHelper.get('contact/fetchforauser', null, this.$router)
        .then((res) => {
          if (!res.success) {
            this.err = this.$lang.errors.failedContactInfo;
            return;
          }
          this.contact = res.body.contact;
          const data = {
            first: this.contact.firstName || '',
            last: this.contact.lastName || '',
            email: this.contact.email || '',
            phone: this.contact.phone || '',
          };
          localStorage.customerData = JSON.stringify(data);
          this.phone = res.body.contact.phone;
        });
      if (this.selectedAddress !== null) {
        this.chosenAddress = this.addressesAT[0];
        this.chosenAddress.postalCode = this.postalCode.postalCode;
        this.postalcode = this.postalCode.postalCode;
      }
    } else if (this.selectedAddress !== null) {
      if (this.$route.params.isCompeteAddress) {
        this.chosenAddress =
            this.addressesAT.find(x =>
              x.latitude === this.postalCode.latitude
                && x.longitude === this.postalCode.longitude);
      } else {
        this.chosenAddress = {};
      }
      this.chosenAddress.postalCode = this.postalCode.postalCode;
      this.postalCodes = [this.postalCode.postalCode];
      this.postalcode = this.postalCode.postalCode;
    }
    if (!auth.isLoggedIn()) {
      if (localStorage.customerData) {
        const data = JSON.parse(localStorage.customerData);
        this.firstName = data.first || '';
        this.lastName = data.last || '';
        this.email = data.email || '';
        this.phone = data.phone || '';
        setTimeout(() => {
          document.getElementById('firstName').focus();
        }, 20);
        setTimeout(() => {
          document.getElementById('lastName').focus();
        }, 40);
        setTimeout(() => {
          document.getElementById('email').focus();
        }, 60);
        setTimeout(() => {
          document.getElementById('phone').focus();
        }, 80);
        setTimeout(() => {
          document.getElementById('firstName').focus();
        }, 100);
      }
    }
  },
  destroyed() {
    this.$store.dispatch('setModal', false);
    if (this.success) {
      this.cleanUp();
    } else {
      this.$store.dispatch('setUserData', {
        firstName: this.firstName,
        lastName: this.lastName,
        phone: this.phone,
        email: this.email,
      });
    }
  },
};
</script>

<style lang="scss">
.theme--light {
  .table {
    background-color: transparent !important;
  }
}

.payment-method {
  margin-top: 0;
  flex: 0 1 auto !important;
}

.section {
  height: auto;
  position: relative;
}

.table-wrap {
  width: 50%;
  max-width: 50%;
  padding: 24px;
  margin-bottom: 16px;
}

.order-wrap {
  width: 49%;
  max-width: 49%;
}

.radio-wrap {
  position: relative;
  flex: 0.5 1 auto !important;
  max-width: 100%;

  .radio-group--column .input-group__input {
    display: inline-flex !important;
  }

  .single-radio {
    padding-left: 32px !important;
  }

  .input-group__details {
    display: none !important;
  }

  .input-group.input-group--selection-controls label {
    width: auto;
    position: relative;
    overflow: visible;
    max-width: 100%;
    left: 0;
    display: inline-block;
    word-wrap: break-word;
  }

  .input-group.input-group--selection-controls .input-group__input {
    width: auto;
    position: absolute;
    left: 0;
    top: 0;
    margin: 0
  }
}

.payment {
  padding-top: 22px;
  flex: 0 1 auto !important;
}

.add-address {
  font-size: 1.1rem;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

.inline {
  display: inline-block;
}

.sub-title {
  font-weight: 700;
  opacity: 0.75;
  font-size: 1.1rem;
}

.agreement {
  p {
    margin-top: 6px;
  }

  a {
    text-decoration: none;
  }

  .v-input {
    flex: 0 0;
  }
}

.details {
  font-size: 0.85em;
  color: rgba(0, 0, 0, 0.5);
}

.price {
  min-width: 56px;
  display: inline-block;
  margin: 0;
  padding-left: 8px;
  position: relative;
  text-align: right;
  font-size: 0.85em;
  color: rgba(0, 0, 0, 0.6);

  &:before {
    content: attr(data-currency);
    position: absolute;
    left: 0;
  }

  &.no-min {
    min-width: 1px;
  }
}

@media only screen and (min-width: 960px) {
  .select-wrap {
    margin-right: 24px;
  }
}

@media only screen and (max-width: 768px) {
  .payment-method {
    width: 100% !important;
  }
}

@media only screen and (max-width: 600px) {
  .payment {
    width: 100% !important;
  }
}

@media only screen and (max-width: 992px) {
  .table-wrap,
  .order-wrap {
    width: 100%;
    max-width: 100%;
  }
  .table-wrap {
    padding: 0;
  }
}
.v-alert {
  border: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/webshop/Order-info.vue